export default __webpack_public_path__ + "static/media/IMG_4544-min.47a86fcd.JPG";